import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_chat/")({
  beforeLoad: () => {
    throw redirect({ to: "/new", replace: true });
  },
  validateSearch: (search: Record<string, unknown>): { task?: string } => {
    const task = search["task"];
    return typeof task === "string" ? { task } : {};
  },
});
